import { render, staticRenderFns } from "./ManterTermosView.vue?vue&type=template&id=4c6bc21a&scoped=true&"
import script from "./ManterTermosView.vue?vue&type=script&lang=js&"
export * from "./ManterTermosView.vue?vue&type=script&lang=js&"
import style0 from "./ManterTermosView.vue?vue&type=style&index=0&id=4c6bc21a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6bc21a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VDataTable,VForm,VRow,VTextField})
